function toInternalTranslationResource(resource) {
  const r = resource;
  if (r.$$type !== "@backstage/TranslationResource") {
    throw new Error(`Invalid translation resource, bad type '${r.$$type}'`);
  }
  if (r.version !== "v1") {
    throw new Error(`Invalid translation resource, bad version '${r.version}'`);
  }
  return r;
}

export { toInternalTranslationResource };
//# sourceMappingURL=TranslationResource.esm.js.map
